import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  EventItemDescription,
  EventItemWrapper,
  EventItemInfo,
  EventItemTitle,
  EventItemText,
  EventDateWrapper,
  EventDateDay,
  EventDateDayWeek,
  EventDateMonth,
  EventItemType,
} from '../styles';

const EventItem = ({
  event: {
    title,
    type,
    coverMedia: {
      image: {
        uri: imageUrl,
      },
    },
    date: {
      startDate,
    },
    location: {
      type: locationType,
      venue,
    },
  },
}) => {
  const dayweek = moment(startDate).format('ddd');
  const day = moment(startDate).format('DD');
  const month = moment(startDate).format('MMM');

  const location = locationType === 'IN_PERSON' ? `${venue.city} ${venue.state}, ${venue.zipCode}` : 'Virtual';

  return (
    <EventItemWrapper bgImage={imageUrl}>
      <EventDateWrapper>
        <EventDateDayWeek>{dayweek}</EventDateDayWeek>
        <EventDateDay>{day}</EventDateDay>
        <EventDateMonth>{month}</EventDateMonth>
      </EventDateWrapper>
      <EventItemDescription>
        <EventItemInfo>
          <EventItemTitle>
            {title}
          </EventItemTitle>
          <EventItemText>
            {location}
          </EventItemText>
        </EventItemInfo>
        <EventItemType>
          {type}
        </EventItemType>
      </EventItemDescription>
    </EventItemWrapper>
  );
};

EventItem.propTypes = {
  event: PropTypes.shape().isRequired,
};

export default EventItem;
